import { ConfirmationModalFooter } from '@/components/ConfirmationModal/Base/Footer';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { ButtonV2Props, Modal } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { Contents } from './Contents';

type ConfirmDisableOfficeSettingModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
};

export const ConfirmDisableOfficeSettingModal: FC<ConfirmDisableOfficeSettingModalProps> =
  memo(({ open, onClose, onConfirm, isPending }) => {
    const containerRef = useGlobalContainerRef();
    const { t } = useTranslation();
    const cancelButtonProps: ButtonV2Props = useMemo(
      () => ({
        isSecondary: true,
        isTertiary: true,
        onClick: onClose,
        size: 'sm',
        children: t('cancel'),
        isDisabled: isPending,
      }),
      [onClose, t, isPending]
    );

    const okButtonProps: ButtonV2Props = useMemo(
      () => ({
        color: 'danger',
        onClick: onConfirm,
        size: 'sm',
        isSecondary: true,
        children: t('ai_agents_setting_main_setting_use_stop_button_label'),
        isLoading: isPending,
        isTransparent: isPending,
        isDisabled: isPending,
        style: {
          minWidth: '90px',
        },
      }),
      [onConfirm, t, isPending]
    );
    return (
      <Modal
        open={open}
        onClose={onClose}
        size='md'
        title={t('ai_agents_setting_main_setting_confirm_disable_start_title')}
        getContainer={containerRef}
        mask
        footer={
          <ConfirmationModalFooter
            cancelButton={cancelButtonProps}
            okButton={okButtonProps}
          />
        }
      >
        <Contents />
      </Modal>
    );
  });

ConfirmDisableOfficeSettingModal.displayName =
  'ConfirmDisableOfficeSettingModal';
